import { AnyAction } from "redux";

import { myFleetActions } from "../reducer/reducer";

export const resetFilter = (): AnyAction => myFleetActions.setFilter({});
